export default __webpack_public_path__ + "static/media/hero_back_2.55047330.jpg";